// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = 'https://giedkdxtrqcqzcockacd.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdpZWRrZHh0cnFjcXpjb2NrYWNkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MzIzMDUsImV4cCI6MjA2OTMwODMwNX0.Ihvb06NJWDS1L6luxIz_WuJ34TyhBHP3Ncgl6uHevgo';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true, // Added to handle invite link sessions
    },
  }
);
